import React from 'react';
import { useTranslation } from 'react-i18next';

// The component now accepts a prop `onNavigate` which will be the `navigateTo` function from App.js
const FeaturesView = ({ onNavigate }) => {
    const { t } = useTranslation();
    const styles = {
        container: { padding: '30px', maxWidth: '800px', margin: '0 auto', textAlign: 'center' }, // Centered text
        title: { borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '20px' },
        featureList: { listStyle: 'none', padding: 0, textAlign: 'left' }, // Text align left for list items
        featureItem: {
            backgroundColor: '#f9f9f9',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '15px',
            borderLeft: '5px solid #007bff'
        },
        featureTitle: { margin: '0 0 10px 0', color: '#0056b3' },
        ctaButton: { // Style for the new button
            backgroundColor: '#28a745',
            color: 'white',
            padding: '15px 30px',
            border: 'none',
            borderRadius: '5px',
            fontSize: '1.2em',
            cursor: 'pointer',
            marginTop: '30px',
            textDecoration: 'none'
        },
        featureButton: {
            display: 'block',
            width: '100%',
            textAlign: 'left',
            background: 'transparent',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            color: 'inherit'
        }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>{t('features_title')}</h2>

            <ul style={styles.featureList}>
                <li style={{...styles.featureItem}}>
                    <button type="button" style={{...styles.featureButton}} onClick={() => onNavigate('patients')}>
                        <h4 style={styles.featureTitle}>{t('feature_patients_title')}</h4>
                        <p>{t('feature_patients_text')}</p>
                    </button>
                </li>
                <li style={{...styles.featureItem}}>
                    <button type="button" style={{...styles.featureButton}} onClick={() => onNavigate('dashboard')}>
                        <h4 style={styles.featureTitle}>{t('feature_consultations_title')}</h4>
                        <p>{t('feature_consultations_text')}</p>
                    </button>
                </li>
                <li style={{...styles.featureItem}}>
                    <button type="button" style={{...styles.featureButton}} onClick={() => onNavigate('billing')}>
                        <h4 style={styles.featureTitle}>{t('feature_billing_title')}</h4>
                        <p>{t('feature_billing_text')}</p>
                    </button>
                </li>
            </ul>
            
            {/* Add a prominent Call to Action button */}
            <button onClick={() => onNavigate('login')} style={styles.ctaButton}>
                {t('feature_cta')}
            </button>
        </div>
    );
};

export default FeaturesView;
